import * as Mui from "@mui/material";
import { Route, Routes } from "react-router";
import VehicleAvailabilitySearch from "../component/vehicle-availability/VehicleAvailabilitySearch";
import VehicleAvailabilityStatus from "../component/vehicle-availability/VehicleAvailabilityStatus";

export interface IVehicleAvailabilityState {
  tenant:string;
  id: number;
  plate: string;
  modelType: string;
  referenceLocationDesc: string;
  referenceLocationType: string;
}

const VehicleAvailabilityPage = () => {
  return (
    <Mui.Box>
      <Routes>
        <Route index={true} element={<VehicleAvailabilitySearch />} />
        <Route path="/status" element={<VehicleAvailabilityStatus />} />
      </Routes>
    </Mui.Box>
  )
}

export default VehicleAvailabilityPage;